module.exports = __webpack_public_path__ + "img/social-youtube.008c2350.svg";